'use strict';

var _themeCart = require('@shopify/theme-cart');

var cart = _interopRequireWildcard(_themeCart);

var _themeCurrency = require('@shopify/theme-currency');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function closeModal(overlay) {
  (0, _jquery2.default)(overlay).addClass('hidden').removeClass('open');
  (0, _jquery2.default)('.modal.open').addClass('hidden').removeClass('open');
  (0, _jquery2.default)('body').css('overflow', 'auto');
}

function openModal() {
  (0, _jquery2.default)('.modal').removeClass('hidden').addClass('open');
  (0, _jquery2.default)('.modal--overlay').removeClass('hidden').addClass('open');
  (0, _jquery2.default)('body').css('overflow', 'hidden');
  centerModal();
  (0, _jquery2.default)('.modal').find('textarea').focus();
}

function centerModal() {
  var modal = (0, _jquery2.default)('.modal.open');
  var mWidth = modal.outerWidth();
  var mHeight = modal.outerHeight();
  var width = (0, _jquery2.default)(window).width();
  var height = (0, _jquery2.default)(window).height();
  if (width % 1 != 0) {
    width = Math.round(width);
  }
  if (height % 1 != 0) {
    height = Math.round(height);
  }
  var topPos = height / 2 - mHeight / 2 + 90;
  var leftPos = width / 2 - mWidth / 2;
  modal.css({ top: topPos, left: leftPos });
}

function addToCartOk() {
  location.reload();
}

(0, _jquery2.default)('body').on('click', '.modal .close, .modal--overlay', function () {
  var overlay = (0, _jquery2.default)('.modal--overlay');
  closeModal(overlay);
});

(0, _jquery2.default)('body').on('click', '.add-on-product', function (e) {
  e.preventDefault();
  openModal();
});

(0, _jquery2.default)('body').on('click', '#addon-modal .btn', function (e) {
  var addonID = (0, _jquery2.default)('.add-on-product').data('variantid');
  var addonNote = (0, _jquery2.default)('#addon-modal textarea').val();
  e.preventDefault();
  _jquery2.default.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {
      items: [{
        id: addonID,
        quantity: 1,
        properties: {
          'Uw boodschap': addonNote
        }
      }]
    },

    success: addToCartOk
  });
});

var checkbox = document.querySelector("#add-note");

checkbox.addEventListener('change', function () {
  if (this.checked) {
    (0, _jquery2.default)('.cart__textarea-title, .cart__textarea').addClass('active');
  } else {
    (0, _jquery2.default)('.cart__textarea-title, .cart__textarea').removeClass('active');
  }
});

(0, _jquery2.default)(".cart form .quantity button").on("click", function (e) {
  e.preventDefault();

  var $button = (0, _jquery2.default)(this);
  var inputQuantity = $button.parent().find("input");
  var oldValue = inputQuantity.val();

  if ($button.text() == "+") {
    var newVal = parseFloat(oldValue) + 1;
  } else {
    if (oldValue > 1) {
      var newVal = parseFloat(oldValue) - 1;
    } else {
      newVal = 1;
    }
  }
  inputQuantity.val(newVal);
  var currentQuantity = newVal;
  var minValue = parseInt(inputQuantity.attr('min'), 10);
  var maxValue = parseInt(inputQuantity.attr('max'), 10);
  var key = inputQuantity.attr('id').split('_', 2)[1];
  var thisObj = inputQuantity;
  updateCartLine(thisObj, currentQuantity, minValue, maxValue, key);
});

(0, _jquery2.default)('input').on('input', function () {
  var currentQuantity = parseInt((0, _jquery2.default)(this).val(), 10);

  var minValue = parseInt((0, _jquery2.default)(this).attr('min'), 10);
  var maxValue = parseInt((0, _jquery2.default)(this).attr('max'), 10);
  var key = (0, _jquery2.default)(this).attr('id').split('_', 2)[1];
  var thisObj = (0, _jquery2.default)(this);

  updateCartLine(thisObj, currentQuantity, minValue, maxValue, key);
});

function updateCartLine(thisObj, currentQuantity, minValue, maxValue, key) {

  if (currentQuantity === minValue) {
    cart.removeItem(key).then(function (state) {
      console.log('This item was removed');
      updateCartTotals(thisObj, currentQuantity, 0, state.total_price);
      removeCartRow(thisObj);
    });
  } else if (!maxValue) {
    cart.updateItem(key, { quantity: currentQuantity }).then(function (state) {
      var currentItem = state.items.find(function (item) {
        return item.key === key;
      });
      console.log('The item with key \'' + key + '\' now has quantity ' + currentItem.quantity + ' and a price of ' + currentItem.price);
      updateCartTotals(thisObj, currentItem.price, currentItem.quantity, finalPrice, state.total_discount, state.total_price);
    });
  } else if (currentQuantity <= maxValue) {
    cart.updateItem(key, { quantity: currentQuantity }).then(function (state) {
      var currentItem = state.items.find(function (item) {
        return item.key === key;
      });
      console.log('2 The item with key \'' + key + '\' now has quantity ' + currentItem.quantity + ' and a price of ' + currentItem.price);
      var finalPrice = thisObj.closest('tr').children('td[data-label="Prijs"]').data('price');
      updateCartTotals(thisObj, currentItem.price, currentItem.quantity, finalPrice, state.total_discount, state.total_price);
    });
  }
}

function updateCartTotals(thisObj, itemPrice, quantity, subtotal, discount, total) {
  var itemTotal = (itemPrice * quantity / 100).toFixed(2);
  console.log(itemPrice);
  var itemTotalMoney = (0, _themeCurrency.formatMoney)(itemTotal, theme.moneyFormat);
  var subtotalMoney = (0, _themeCurrency.formatMoney)(subtotal, theme.moneyFormat);
  var discountMoney = (0, _themeCurrency.formatMoney)(discount, theme.moneyFormat);
  var totalMoney = (0, _themeCurrency.formatMoney)(total, theme.moneyFormat);
  thisObj.closest('tr').children("td.cart-money[data-label='Total']").text('' + itemTotalMoney);
  (0, _jquery2.default)('#subtotal').text('' + subtotalMoney);
  (0, _jquery2.default)('#discount').text('' + discountMoney);
  (0, _jquery2.default)('#total').text('' + totalMoney);
}

function removeCartRow(thisObj) {
  thisObj.parents().eq(1).remove();
}